<template>
  <div id="app">
    <v-app id="inspire">
      <v-layout row>
        <v-flex xs12>
          <v-card>
            <v-list>
              <v-list-group
                v-for="item in statusDisplayNames"
                :key="item.registrationStatus"
                no-action
              >
                <v-list-tile slot="activator">
                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.registrationStatus }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile>
                  <v-list-tile-content>
                    <v-flex pa-2 xs12 align-center>
                      <strong>Display name: </strong>{{ item.displayName }}
                    </v-flex>
                  </v-list-tile-content>
                  <v-list-tile-content>
                    <v-flex pa-2 xs12 align-center><strong>Display message: </strong>{{ item.message }}</v-flex>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn color="lime"
                      :disabled="!isWriteAvailable"
                      fab flat
                      @click.stop="editDisplayName(item)"
                    >
                      <v-icon>create</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list-group>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-app>

    <v-dialog persistent v-model="modalWindow" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline"> Edit {{items.registrationStatus}} status</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                  <content-field
                    label="Display Name"
                    v-model="items.displayName"
                    @input="$v.items.displayName.$touch"
                    @blur="$v.items.displayName.$touch"
                    :error="$v.items.displayName"
                  />
                  <content-field
                    multi-line
                    label="Display message"
                    v-model="items.message"
                    @input="$v.items.message.$touch"
                    @blur="$v.items.message.$touch"
                    :error="$v.items.message"
                  />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="blue darken-1" flat @click.stop="close">Cancel</v-btn>
          <v-btn color="blue darken-1" flat @click.stop="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { required } from 'vuelidate/lib/validators'
  import mixins from '@/utils/mixins'

  export default {
    name: 'statusDisplayNames',
    mixins: [mixins.isWriteAvailable],
    data () {
      return {
        items: {},
        defaultItem: {
          displayName: "",
          message: ''
        },
        modalWindow: false,
        // DON'T DELETE! need for isWriteAvailable mixin
        scopeForWrite: 'registration:write'
      }
    },
    computed: {
      ...mapGetters(['statusDisplayNames'])
    },
    watch: {
      modalWindow (val) {
        if(!val) this.close()
      }
    },
    methods: {
      ...mapActions(['getStatusDisplayNames', 'updateStatusDisplayNames', 'showResultErrorMessage']),
      editDisplayName (item) {
        this.items = Object.assign({}, item)
        this.modalWindow = true
      },
      close () {
        this.$v.items.$reset()
        this.modalWindow = false
      },
      save () {
        this.$v.items.$touch()
        if (this.$v.items.$invalid) return
        this.update(this.items)
      },
      reset () {
        this.filterInput = ''
        this.showFilter = false
      },
      async get () {
        await this.getStatusDisplayNames()
      },
      async update (item) {
        try {
          await this.updateStatusDisplayNames(item)
          await this.get()
          this.close()
        } catch (err) {
          this.showResultErrorMessage(err)
        }
      }
    },
    async beforeMount () {
      await this.get()
    },
    validations () {
      return {
        items: {
          displayName: { required },
          message: { required }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Registration/Settings/statusSettings.vue